module.exports = __webpack_public_path__ + "static/media/MAYANS_Kilian_+Z.40acb089.jpg";